module.exports = __webpack_public_path__ + "fonts/VetoSans-Bold.2398a137.eot";